import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import NewsPage from './pages/NewsPage';
import VideosPage from './pages/VideosPage';
import GalleryPage from './pages/GalleryPage';
import NewsPostPage from './pages/NewsPostPage';
import VideoPostPage from './pages/VideoPostPage';
import GalleryPostPage from './pages/GalleryPostPage';
import BlogUploadPage from './pages/BlogUploadPage';
import BlogPostPage from './pages/BlogDisplayPage';
import BlogsPage from './pages/BlogsPage';
import NewsUploadPage from './pages/NewsUploadPage';
import VideoUploadPage from './pages/VideoUploadPage';
import GalleryUploadPage from './pages/GalleryUploadPage';
import ClientInquiriesPage from './pages/ClientInquiriesPage';
import ClientInquiryReply from './pages/ClientInquiryReply';
import UploadPage from './pages/UploadPage';

function App() {
  return (
    <>
      <style>
        {`
          .app-root-container {
            min-height: 100vh !important;
            margin: 0 !important;
            padding: 0 !important;
          }
          .app-main-content {
            margin: 0 !important;
            padding: 0 !important;
            margin-top: 0 !important;
          }
        `}
      </style>
      
      <div className="app-root-container">
        <Header />
        <main className="main-content app-main-content">
          <Routes>
            {/* Main Pages */}
            <Route path="/" element={<Home />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/videos" element={<VideosPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/blogs" element={<BlogsPage />} />
            <Route path="/contact" element={<ClientInquiriesPage />} />
            
            {/* Individual Post Pages */}
            <Route path="/news/:token" element={<NewsPostPage />} />
            <Route path="/video/:token" element={<VideoPostPage />} />
            <Route path="/gallery/:token" element={<GalleryPostPage />} />
            <Route path="/blog/:token" element={<BlogPostPage />} />
            
            {/* Upload Pages */}
            <Route path="/upload" element={<BlogUploadPage />} />
            <Route path="/upload-news" element={<NewsUploadPage />} />
            <Route path="/upload-video" element={<VideoUploadPage />} />
            <Route path="/upload-gallery" element={<GalleryUploadPage />} />
            <Route path="/upload" element={<UploadPage />} />
            {/* Support/Admin Pages */}
            <Route path="/support-reply" element={<ClientInquiryReply />} />
          </Routes> 
        </main>
      </div>
    </>
  );
}

export default App;
